import { styles } from './template.scss';
import { styles as commonStyles } from '../../../assets/common.scss';
import { styles as colorHelpersStyles } from '../../../assets/color-helpers.scss';
import { styles as widgetSharedStyles } from '../../../assets/widget-shared.scss';
import { styles as flexboxHelpersStyles } from '../../../assets/flexbox-helpers.scss';
import { styles as styleHelpers } from '../../../assets/style-helpers.scss';
import { styles as textHelpersStyles } from '../../../assets/text-helpers.scss';
import {FontSizes, FontWeights} from "../../../types/common/types";

export const templateIntegrationsMarketplaceGridAvailable = document.createElement('template');

templateIntegrationsMarketplaceGridAvailable.innerHTML = `
  <style>${widgetSharedStyles}</style>
  <style>${colorHelpersStyles}</style>
  <style>${flexboxHelpersStyles}</style>
  <style>${styleHelpers}</style>
  <style>${textHelpersStyles}</style>
  <style>${commonStyles}</style>
  <style>${styles}</style>
  <div class="wrapper">
    <gz-custom-template-list
      id="cardboard_available_grid" class="custom-template-list">
    </gz-custom-template-list>
</div>
`;
